module.exports = __webpack_public_path__ + "static/img/video_platform2.da3c53c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_platform2.png
// module id = YpjK
// module chunks = 0